import * as brandColors from '../../../utils/brand-colors';

export default () => ({
  root: { display: 'flex' },
  container: { width: 20 },
  moreContainer: {
    backgroundColor: brandColors.grey[100],
    color: brandColors.grey[500],
    border: '2px solid white',
    borderRadius: 16,
    height: 32,
    minWidth: 32,
    lineHeight: '32px',
    textAlign: 'center',
    zIndex: 1,
    fontSize: '13px',
    padding: '0 6px',
  },
});
